import React from 'react';
import { Modal } from 'react-bootstrap';
import deleteImage from '../../assets/images/delete.png';
import './DeleteModel.scss';

export default function DeleteModel({ isOpen, open, title, message, isDelete, variant }) {
  if (variant === 'panel') {
    return (
      <Modal
        centered
        className="delete-panel"
        dialogClassName="delete-panel__dialog"
        contentClassName="delete-panel__content"
        show={open}
        onHide={() => {
          isOpen(false);
        }}
      >
        <Modal.Header className="delete-panel__header">
          <div className="delete-panel__header-content">
            <span className="delete-panel__header-icon" aria-hidden="true">
              <i className="icofont-ui-delete" />
            </span>
            <div className="delete-panel__header-copy">
              <Modal.Title className="fw-bold delete-panel__title">{title}</Modal.Title>
            </div>
          </div>
          <button
            type="button"
            className="btn-close delete-panel__close"
            aria-label="Close"
            onClick={() => {
              isOpen(false);
            }}
          />
        </Modal.Header>
        {message ? (
          <Modal.Body className="delete-panel__body">
            <p className="delete-panel__message">{message}</p>
          </Modal.Body>
        ) : null}
        <Modal.Footer className="delete-panel__footer">
          <button
            type="button"
            className="btn delete-panel__cancel"
            onClick={() => {
              isOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn delete-panel__submit"
            onClick={() => {
              isDelete();
            }}
          >
            <i className="icofont-ui-delete" aria-hidden="true" />
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal
      centered
      show={open}
      onHide={() => {
        isOpen(false);
      }}
    >
      <Modal.Body>
        <div className="m-2">
          <img
            src={deleteImage}
            height={70}
            width={70}
            style={{ margin: 'auto', display: 'block' }}
          />
          <br />
          <h5 className="text-center">{title}</h5>
          <p className="text-center">{message}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-danger text-light"
          onClick={() => {
            isDelete();
          }}
        >
          Delete
        </button>
        <button
          type="button"
          onClick={() => {
            isOpen(false);
          }}
          className="btn btn-primary"
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
}
